export const DEFAULT_COVER_POSITION = 50;

function normalizeCoordinate(value) {
    const coordinate = typeof value === 'number' ? value : Number.NaN;

    return Number.isFinite(coordinate) && coordinate >= 0 && coordinate <= 100 ? coordinate : DEFAULT_COVER_POSITION;
}

export function normalizeCoverPosition(position) {
    return {
        position_x: normalizeCoordinate(position?.position_x),
        position_y: normalizeCoordinate(position?.position_y),
    };
}

export function coverPositionCssVars(position) {
    const normalized = normalizeCoverPosition(position);

    return {
        '--acc-cover-position-x': `${normalized.position_x}%`,
        '--acc-cover-position-y': `${normalized.position_y}%`,
    };
}
